import TokenManager from './token-manager';

export default {
  TokenManager,
};
